/**
 * Format angka untuk konteks Indonesia: titik sebagai pemisah ribuan,
 * tanpa trailing desimal untuk rupiah. "45.000", bukan "45,000.00".
 * Tidak pernah notasi ilmiah (PRODUCT.md a11y).
 */
const idNumber = new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 });

/** Format nilai rupiah. formatRupiah(45000) → "45.000". */
export function formatRupiah(value: number, opts?: { symbol?: boolean }): string {
  const rounded = Math.round(value);
  const body = idNumber.format(Math.abs(rounded));
  const sign = rounded < 0 ? "-" : "";
  return opts?.symbol ? `${sign}Rp ${body}` : `${sign}${body}`;
}

/** Pembulatan kas ke 100 terdekat (kasir tunai, rfc-003). */
export function roundCash(value: number): number {
  return Math.round(value / 100) * 100;
}

/** Format kuantitas (stok/qty) — bilangan bulat lokal. */
export function formatQty(value: number): string {
  return idNumber.format(value);
}
